// Vue mixin som sätter lifecycle statusar under data:

import Vue from 'vue';

//------------------------------------------------------------------------------------------------------------------------------

const mixin = {

	data() {
		return {
			lifecycleStatuses: {
				// Namngivna med 'mixin' som prefix för att tydliggöra att ordningen på en mixins hooks och en apps/components hooks spelar roll, se kommentarer under mounted nedan:
				//mixinBeforeCreateHasOccured: false,
				mixinCreatedHasOccured: false,
				mixinBeforeMountHasOccured: false,
				mixinMountedHasOccured: false,
				mixinMountedAndNextTickHasOccured: false,
				mixinMountedAndSecondNextTickHasOccured: false,
			}
		};
	},

	//beforeCreate() {
	//	// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

	//	// Funkar inte, för den är inte tillräckligt skapad för att lifecycleStatuses ska vara accessbar:
	//	this.lifecycleStatuses.mixinBeforeCreateHasOccured = true;
	//},

	created() {
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		this.lifecycleStatuses.mixinCreatedHasOccured = true;
	},

	beforeMount() {
		// Called right before the mounting begins: the render function is about to be called for the first time.
		// This hook is not called during server-side rendering.
		// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
		// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).

		this.lifecycleStatuses.mixinBeforeMountHasOccured = true;
	},

	mounted() {
		// Called after the instance has been mounted, where el is replaced by the newly created vm.$el. If the root instance is mounted to an in-document element, vm.$el will also be in-document when mounted is called.
		// Note that mounted does not guarantee that all child components have also been mounted.
		// This hook is not called during server-side rendering.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 1. Mixins mounted hook:  #################################		
		//console.log('1. Mixins mounted hook');

		this.lifecycleStatuses.mixinMountedHasOccured = true;

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 3. Mixins mounted hook + nextTick (DOM not updated yet):  #################################		
			//console.log('3. Mixins mounted hook + nextTick (DOM not updated yet)');

			this.lifecycleStatuses.mixinMountedAndNextTickHasOccured = true;

			Vue.nextTick(function () {

					//## 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated):  #################################		
					//console.log('5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated)');

					this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured = true;

				}
				, this	// Vue.nextTick 'this' context.
			);

		});
	}





	//beforeUpdate() {
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
		// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//},

	//updated() {
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// Note that updated does not guarantee that all child components have also been re-rendered. If you want to wait until the entire view has been re-rendered, you can use vm.$nextTick inside of updated:
	//	// updated() {
	//	//  this.$nextTick(function () {
	//	//    // Code that will run only after the
	//	//    // entire view has been re-rendered
	//	//  })
	//	// }
	//	// This hook is not called during server-side rendering.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
		// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."

	//	// Flyttad till en watch, bl.a. för att inte dubbelanropas:
	//	//SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');
	//},

	//activated() {
	//	// Called when a kept-alive component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated() {
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	//beforeDestroy() {
	//	// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
	//	// This hook is not called during server-side rendering.
	//},

	//destroyed() {
	//	// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
	//	// This hook is not called during server-side rendering.
	//},

};

export { mixin as euiLifecycleStatusesMixin };

